import { render, staticRenderFns } from "./CrmContent.vue?vue&type=template&id=5bcafb15&scoped=true"
import script from "./CrmContent.vue?vue&type=script&lang=js"
export * from "./CrmContent.vue?vue&type=script&lang=js"
import style0 from "./CrmContent.vue?vue&type=style&index=0&id=5bcafb15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcafb15",
  null
  
)

export default component.exports